export default __webpack_public_path__ + "assets/71d541c09c0d41e2fa18e036eae7f563.png";